import React, { FC, ReactElement, useEffect } from "react";
import { Result } from "antd";
import * as Sentry from "@sentry/react";

interface Props {
  origin: string;
  subdomain?: string;
}

export const UnsupportedSubdomainPage: FC<Props> = ({
  subdomain,
  origin,
}): ReactElement => {
  useEffect(() => {
    const context = subdomain
      ? `Unsupported subdomain: ${subdomain}`
      : "Unsupported subdomain";
    Sentry.captureMessage(context, { extra: { origin } });
  }, [origin, subdomain]);

  const subTitle = subdomain
    ? `The subdomain "${subdomain}" is not configured for this dashboard.`
    : "This subdomain is not configured for this dashboard.";

  return (
    <Result
      status="403"
      title="Unsupported subdomain"
      subTitle={`${subTitle} Please check the URL or contact support.`}
    />
  );
};
